import { z } from 'zod';

export const RoomSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.object({
    url: z.string(),
  }),
  price: z
    .object({
      amount: z.number().nullable(),
      currencyCode: z.string().nullable(),
    })
    .nullable(),
});
